import "./Authentication.scss";

import { Routes, Route } from "react-router-dom";

import SignUp from "../../components/SignUp/SignUp";
import SignIn from "../../components/SignIn/SignIn";

const Authentication = () => {
  return (
    <div className="authentication-container">
      <Routes>
        <Route index element={<SignIn />} />
        <Route path="sign-up" element={<SignUp />} />
      </Routes>
    </div>
  );
};

export default Authentication;
